<template>
  <v-card class="base-card shadow">
    <v-card-title class="headline accent--text pb-4">
      {{ title }}
    </v-card-title>

    <v-card-text>
      <CardFieldRow
        v-model="overseasEvent.organizationName"
        label="Название учреждения"
        placeholder="Добавьте название учреждения"
        :disabled="isShowMode"
        :error-messages="errorMessages.organizationName"
        :required="!isShowMode"
        @input="
          $v.overseasEvent.organizationName.$touch()
          updateOverseasEvent()
        "
      />

      <CardDateRow
        v-model="overseasEvent.fromDate"
        label="Начало мероприятия"
        placeholder="Добавьте дату начало мероприятия"
        :disabled="isShowMode"
        :error-messages="errorMessages.fromDate"
        :required="!isShowMode"
        @input="
          $v.overseasEvent.fromDate.$touch()
          updateOverseasEvent()
        "
      />

      <CardDateRow
        v-model="overseasEvent.toDate"
        label="Конец мероприятия"
        placeholder="Добавьте дату конца мероприятия"
        :disabled="isShowMode"
        :error-messages="errorMessages.toDate"
        :required="!isShowMode"
        @input="
          $v.overseasEvent.toDate.$touch()
          updateOverseasEvent()
        "
      />

      <CardFieldRow
        v-model="overseasEvent.stayPlace"
        label="Место пребывания (страна, город)"
        placeholder="Добавьте место пребывания"
        :disabled="isShowMode"
        :error-messages="errorMessages.stayPlace"
        :required="!isShowMode"
        @input="
          $v.overseasEvent.stayPlace.$touch()
          updateOverseasEvent()
        "
      />

      <CardAutocompleteRow
        v-model="overseasEvent.participationKind"
        :items="participationKindList"
        item-value="id"
        item-text="name"
        label="Вид исполнения"
        placeholder="Выберите вид исполнения"
        hide-border-bottom
        :disabled="isShowMode"
        :required="!isShowMode"
        :error-messages="errorMessages.participationKind"
        @input="
          $v.overseasEvent.participationKind.$touch()
          updateOverseasEvent()
        "
      />
    </v-card-text>
  </v-card>
</template>

<script>
import { OverseasEvent } from '@/models'
import { required, maxLength } from 'vuelidate/lib/validators'
import { checkDate, setValidateMessages, compareTwoDates } from '../../../scripts/validation'
import CardFieldRow from '../../ui/row/CardFieldRow'
import CardAutocompleteRow from '../../ui/row/CardAutocompleteRow'
import CardDateRow from '../../ui/row/CardDateRow'
import { mapGetters } from 'vuex'

export default {
  components: { CardDateRow, CardAutocompleteRow, CardFieldRow },
  props: {
    isShowMode: Boolean,
    selectedItem: Object,
    title: String
  },

  mounted() {
    this.updateInvalid()
  },

  data: () => ({
    overseasEvent: new OverseasEvent()
  }),

  validations() {
    return {
      overseasEvent: {
        organizationName: { required, maxLength: maxLength(300) },
        fromDate: { required, checkDate },
        toDate: {
          required,
          checkDate,
          compareTwoDates
        },
        stayPlace: { required, maxLength: maxLength(100) },
        participationKind: { required, maxLength: maxLength(100) }
      }
    }
  },

  computed: {
    ...mapGetters('dictionaries', ['participationKindList']),

    errorMessages() {
      const allErrors = {}

      Object.keys(this.$v.overseasEvent.$params).forEach(key => {
        allErrors[key] = setValidateMessages(this.$v.overseasEvent[key])
      })

      return allErrors
    }
  },

  methods: {
    updateInvalid() {
      this.$emit('updateInvalid', this.$v.$invalid)
    },

    async updateOverseasEvent() {
      this.$emit('update:selected-item', new OverseasEvent(this.overseasEvent.getForAPI()))
      this.updateInvalid()
    }
  },

  watch: {
    selectedItem: {
      immediate: true,
      deep: true,
      handler(val) {
        this.overseasEvent = new OverseasEvent(val.getForAPI())
        this.updateInvalid()
      }
    }
  }
}
</script>

<style scoped></style>
